import React from 'react';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { FormattedDate, FormattedTime, FormattedMessage } from 'react-intl';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';
import moment from 'moment';

export enum Availability {
  NONE,
  FEW,
  MANY,
  BACKOFFICE_ONLY,
  CANCELLED,
};

interface IProps {
  performance: Julius.Website.PerformanceViewModel;
  onClick: (performanceID: number) => void;
}

const PerformanceItem: React.SFC<IProps> = ( {
  performance: {
    id,
    venue,
    city,
    date,
    minPrice,
    extraInfo,
    availabilityStatus,
    availabilityInfo,
    isOpenForSale,
    startSaleDate,
    isClickable,
    preSaleIsActive,
  },
  onClick,
} ) => {
  const isOpeningSoon = !isOpenForSale && startSaleDate && startSaleDate.getTime() > new Date().getTime();
  
  const PurchaseButton: React.SFC<{}> = () => {
    if (isOpenForSale) {
      if (isClickable) {
        if (preSaleIsActive) {
          return (
            <Button onClick={ () => onClick(id) }>
              <FormattedText 
                displayName='Förköp'
                formattedName='event.presale'
              />
            </Button>
          );
        } else {
          if (availabilityStatus === Availability.FEW) {
            return (
              <Button onClick={ () => onClick(id) }>
                <FormattedText 
                  displayName='Fåtal kvar'
                  formattedName='event.fewtickets'
                />
              </Button>
            );
          } else {
            return (
              <Button onClick={ () => onClick(id) }>
                <FormattedText 
                  displayName='Köp biljetter'
                  formattedName='event.buytickets'
                />
              </Button>
            );
          }
        }
      } else {
        return (
          <div className='availability-info'>
            { availabilityInfo }
          </div>
        );
      }
    } else {
      if (isOpeningSoon) {
        return (
          <div className='availability-info soon'>
            {/* <FormattedMessage 
              id='event.opensoon'
              defaultMessage='Biljettsläpp inom kort'
              values={ { 
                startSaleDate:
                  <DateSpan 
                    dateFormat='medium' 
                    firstDate={ startSaleDate } 
                  />,
              } }
            /> */}
            { startSaleDate ? (
              <>
                <div>
                  Biljettsläpp
                </div>
                <div>
                  { moment(startSaleDate).format('LLLL') }
                </div>
              </>
            ) : (
              <div>
                Biljettsläpp inom kort
              </div>
            )}
          </div>
        );
      } else {
        return (
          <div className='availability-info closed'>
            <FormattedText 
              formattedName='event.closed'
              displayName='Inte tillgänglig'
            />
          </div>
        );
      }
    }
  }

  const Price: React.SFC<{}> = () => (
    <div className='price'>
      <FormattedText 
        style='sub-title'
        displayName='Biljettkategorier'
        formattedName='event.ticketcategories'
      />
      { (availabilityStatus === Availability.NONE || 
        availabilityStatus === Availability.CANCELLED) ?
        <span>-</span> :
        <FormattedMessage
          id='global.fromprice'
          defaultMessage=''
          values={ { price: minPrice } }
        />
      }
    </div>
  );

  const Location: React.SFC<{}> = () => (
    <div className='location'>
      <span className='sub-title'>{ venue }</span>
      <span>{ city }</span>
    </div>
  );

  const PerformanceDate: React.SFC<{}> = () => (
    <div className='date'>
      { extraInfo && <span className="sub-title">{ extraInfo }</span> }
      <span className='sub-title capitalize'>
        <FormattedDate 
          value={ date }
          month='long'
          day='numeric'
          year='numeric'
        />
      </span>
      <span className='capitalize'>
        <FormattedTime 
          value={ date }
          hour='numeric'
          minute='numeric'
          weekday='long'
        />
      </span>
    </div>
  );

  const className: string = (() => {
    if (availabilityStatus === Availability.FEW) {
      return `performance-item seats-few`;
    }
    if (availabilityStatus === Availability.MANY) {
      return `performance-item seats-many`;
    }
    return `performance-item seats-none`;
  })();

  return (
    <div className={ className }>
      <Icon type='tag-o' />
      <PerformanceDate />
      <Location />
      <Price />
      <PurchaseButton />
    </div>
  );
}

export default PerformanceItem;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/PerformanceList/PerformanceItem.tsx